module dg.clients {

    angular.module('dg.clients', []);
}